<template>
  <div class="image-wrapper">
    <!-- Action Icons -->
    <div class="image-actions">
      <v-btn
        icon
        size="small"
        variant="text"
        color="primary"
        @click="openInNewTab"
      >
        <v-icon size="x-large">mdi-open-in-new</v-icon>
      </v-btn>

      <v-btn
        icon
        size="small"
        variant="text"
        color="primary"
        @click="downloadImage"
      >
        <v-icon size="x-large">mdi-download</v-icon>
      </v-btn>
    </div>

    <!-- Image -->
    <img
      :src="file.file_64"
      :alt="file.name"
      class="image max-digitalmedia-width"
    />
  </div>
</template>

<script>
export default {
  name: "FileImage",
  props: {
    file: {
      type: Object,
      required: true
    }
  },
  methods: {
    openInNewTab() {
      const newWindow = window.open();
      newWindow.document.write(
        `<img src="${this.file.file_64}" style="width:100%;" />`
      );
    },
    downloadImage() {
      const link = document.createElement("a");
      link.href = this.file.file_64;
      link.download = this.file.name || "image";
      link.click();
    }
  }
};
</script>

<style scoped>
.image-wrapper {
  position: relative;
  width: 100%;
}

.image {
  width: 100%;
  border-radius: 8px;
  object-fit: contain;
}

/* Top-right overlay */
.image-actions {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  gap: 4px;
  background: rgb(var(--v-theme-light));
  padding: 4px;
  border-radius: 8px;
  backdrop-filter: blur(4px);
}
</style>